export type QrCodeType = 'campaign' | 'permanent';

export type DotType = 'square' | 'rounded' | 'dots' | 'classy' | 'classy-rounded' | 'extra-rounded';
export type CornerSquareType = 'square' | 'extra-rounded' | 'dot';
export type CornerDotType = 'square' | 'dot';
export type ErrorCorrectionLevel = 'L' | 'M' | 'Q' | 'H';

export interface QrCustomization {
  dotsOptions: { type: DotType; color: string };
  cornersSquareOptions: { type: CornerSquareType; color: string };
  cornersDotOptions: { type: CornerDotType; color: string };
  backgroundOptions: { color: string };
  imageOptions: { imageSize: number; margin: number; hideBackgroundDots: boolean };
  qrOptions: { errorCorrectionLevel: ErrorCorrectionLevel };
}

export interface QrCodeRecord {
  campaign_id: string;
  type: QrCodeType;
  campaign_name: string;
  description?: string;
  start_date?: string;
  end_date?: string;
  customization: QrCustomization;
  logo_s3_key?: string;
  logo_url?: string;
  scan_count: number;
  last_scanned_at?: string;
  created_at: string;
  created_by: string;
  archived: boolean;
  version: number;
}

export interface CreateQrCodePayload {
  campaign_id: string;
  type: QrCodeType;
  campaign_name: string;
  description?: string;
  start_date?: string;
  end_date?: string;
  customization: QrCustomization;
  logo_s3_key?: string;
}

export const SOCIALSPARK_GREEN = '#10b981';

export const ALLOWED_LOGO_CONTENT_TYPES = ['image/png', 'image/jpeg', 'image/svg+xml'] as const;
export const MAX_LOGO_BYTES = 500 * 1024; // 500KB
export const MAX_LOGO_DIMENSION = 1024;

export interface UploadLogoResponse {
  s3_key: string;
  upload_url: string;
  expires_in: number;
}

export const DEFAULT_CUSTOMIZATION: QrCustomization = {
  dotsOptions: { type: 'rounded', color: SOCIALSPARK_GREEN },
  cornersSquareOptions: { type: 'extra-rounded', color: SOCIALSPARK_GREEN },
  cornersDotOptions: { type: 'dot', color: SOCIALSPARK_GREEN },
  backgroundOptions: { color: '#ffffff' },
  imageOptions: { imageSize: 0.28, margin: 4, hideBackgroundDots: true },
  qrOptions: { errorCorrectionLevel: 'M' },
};
